( function( app ) {
  const COMPONENT = {
    init: function() {
      const $form = $( '.cpt-filter-form' );
      const postType = $form.data( 'post-type' );
      const lockedFilters = $form.data( 'locked-filters' ) || {};

      // Hydrate form from URL params on page load
      const urlParams = new URLSearchParams( window.location.search );
      const urlKey = ( taxonomy ) => taxonomy.replace( /^ll_/, '' );
      let hasParams = false;

      $form.find( 'select' ).each( function() {
        const taxonomy = $( this ).attr( 'data-taxonomy' );
        if ( urlParams.has( urlKey( taxonomy ) ) ) {
          $( this ).val( urlParams.get( urlKey( taxonomy ) ) );
          hasParams = true;
        }
      } );


      $form.find( '.cpt-filter-checkbox input' ).each( function() {
        const taxonomy = $( this ).attr( 'data-taxonomy' );
        const value = $( this ).val();

        if ( urlParams.has( urlKey( taxonomy ) ) ) {
          const values = urlParams.getAll( urlKey( taxonomy ) );
          if ( values.includes( value ) ) {
            $( this ).prop( 'checked', true );
            hasParams = true;
          }
        }
      } );

      if ( urlParams.has( 'text_search' ) ) {
        $form.find( 'input[type="search"]' ).val( urlParams.get( 'text_search' ) );
        hasParams = true;
      }

      const initialPage = urlParams.has( 'page' ) ? parseInt( urlParams.get( 'page' ) ) : 1;

      if ( hasParams || initialPage > 1 ) {
        // Save initial URL state so popstate fires correctly when navigating back here
        history.replaceState( buildState( initialPage ), '' );
        filterPosts( initialPage, false );
      }

      $form.on( 'submit', function( e ) {
        e.preventDefault();
        filterPosts();
      } );

      $form.find( 'select' ).on( 'change', function( e ) {
        e.preventDefault();
        filterPosts();
      } );

      $form.find( '.cpt-filter-checkbox input' ).on( 'change', function( e ) {
        e.preventDefault();
        filterPosts();
      } );

      $( document ).on( 'click', '.cpt-filter-results .blog__pagination button', function( e ) {
        e.preventDefault();
        filterPosts( $( this ).attr( 'data-value' ), true, true );
      } );

      $( window ).on( 'popstate', function( e ) {
        const state = e.originalEvent.state;

        if ( state ) {
          $form.find( 'select' ).each( function() {
            const taxonomy = $( this ).attr( 'data-taxonomy' );
            $( this ).val( state.filters[taxonomy] || '' );
          } );
          $form.find( '.cpt-filter-checkbox input' ).each( function() {
            const taxonomy = $( this ).attr( 'data-taxonomy' );
            const value = $( this ).val();
            const stateValues = state.filters[taxonomy];
            $( this ).prop( 'checked', Array.isArray( stateValues ) ? stateValues.includes( value ) : stateValues === value );
          } );
          $form.find( 'input[type="search"]' ).val( state.text_search || '' );
          filterPosts( state.page, false );
        } else {
          $form.find( 'select' ).val( '' );
          $form.find( '.cpt-filter-checkbox input' ).prop( 'checked', false );
          $form.find( 'input[type="search"]' ).val( '' );
          filterPosts( 1, false );
        }
      } );

      function buildState( page ) {
        const filters = {};
        $form.find( 'select' ).each( function() {
          if ( $( this ).val() ) {
            filters[$( this ).attr( 'data-taxonomy' )] = $( this ).val();
          }
        } );
        $form.find( '.cpt-filter-checkbox input:checked' ).each( function() {
          const taxonomy = $( this ).attr( 'data-taxonomy' );
          if ( !filters[taxonomy] ) filters[taxonomy] = [];
          filters[taxonomy].push( $( this ).val() );
        } );
        return {
          filters,
          text_search: $form.find( 'input[type="search"]' ).val() || '',
          page,
        };
      }

      function filterPosts( page = 1, pushState = true, moveFocus = false ) {
        const state = buildState( page );

        if ( pushState ) {
          const params = new URLSearchParams();
          Object.entries( state.filters ).forEach( ( [taxonomy, value] ) => {
            const key = urlKey( taxonomy );
            if ( Array.isArray( value ) ) {
              value.forEach( ( v ) => params.append( key, v ) );
            } else {
              params.set( key, value );
            }
          } );
          if ( state.text_search ) params.set( 'text_search', state.text_search );
          if ( page > 1 ) params.set( 'page', page );

          const newUrl = params.toString() ?
            `${ window.location.pathname }?${ params.toString() }` :
            window.location.pathname;

          history.pushState( state, '', newUrl );
        }

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filter',
          data: {
            page: state.page,
            filters: Object.assign( {}, lockedFilters, state.filters ),
            text_search: state.text_search,
            post_type: postType,
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
            $( '.cpt-filter-results__wrapper' ).attr( 'aria-busy', 'true' );
          },
          success: function( data ) {
            $( '.cpt-filter-results__wrapper' ).html( data.results );
            if ( moveFocus ) {
              const $status = $( '.cpt-filter-results__wrapper [role="status"]' );
              if ( $status.length ) {
                $status.attr( 'tabindex', '-1' ).trigger( 'focus' );
              }
            }
          },
          error: function( _jqXHR, _status, error ) {
            console.log( error );
          },
          complete: function( _jqXHR, _status ) {
            doingAjax = false;
            $( '.cpt-filter-results__wrapper' ).attr( 'aria-busy', 'false' );
          },
        } );
      }
    },
    finalize: function() {},
  };

  app.registerComponent( 'cpt-filter-form', COMPONENT );
} )( app );
